import { DashboardState } from '@galabid/gb-dashboard/core/data-access'
import { Action, ActionReducer } from '@ngrx/store'
import * as dashboardActions from './dashboard.actions'

/**
 * NgRx Meta-Reducer: flushDashboardMetaReducer
 *
 * Resets most of the application's state to its initial values,
 * while selectively preserving key data slices.
 *
 * This ensures a clean slate, for instance, when navigating between auctions,
 * preventing data from one auction from showing in another.
 * It keeps 'auction', 'account', 'countrySpec', and 'tutorialVideos' state.
 *
 * @param reducer The root NgRx reducer.
 */
export const flushDashboardMetaReducer =
  (reducer: ActionReducer<any>): ActionReducer<any> =>
  (state, action) => {
    if (action.type === dashboardActions.flushDashboardState.type && !!state) {
      const persistedState = {
        account: state.account,
        countrySpec: state.countrySpec,
        tutorialVideos: state.tutorialVideos,
        siteAnnouncements: state.siteAnnouncements,
        smsServices: state.smsServices,
        globalPreferences: state.globalPreferences,
      }

      const initialDashboardState = reducer(undefined, { type: '@ngrx/store/init' } as Action)
      return {
        ...initialDashboardState,
        ...persistedState,
      } as DashboardState
    }
    return reducer(state, action)
  }
